module.exports = __webpack_public_path__ + "img/DefaultProfileImage.a4d7ef82.svg";